<template>
  <div class="training-intents">
    <main-layout>
      <template v-if="currentView == 'list'">
        <div style="position: relative; min-height: 100vh">
          <v-premium-plan-popup
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            :show-all="false"
            margin-top="65"
          ></v-premium-plan-popup>
          <div class="container-fluid" style="padding: 25px 15px">
            <div class="row">
              <div class="col s12 m8">
                <h5>{{ $t('Default Conversation') }}</h5>
              </div>
              <div class="col s12 m4 form-control">
                <input v-model="search" type="text" :placeholder="$t('Search')" />
              </div>
            </div>
            <div class="row">
              <div class="col s12 m8" style="overflow-x: auto; white-space: nowrap">
                <!--:class="{'btn-primary': currentFilter == 'today' , 'btn-outline-gray' : currentFilter != 'today' }" -->
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'today'"
                  :outline="currentFilter != 'today'"
                  :color="currentFilter == 'today' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('today')"
                  >{{ $t('today') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_month'"
                  :outline="currentFilter != 'this_month'"
                  :color="currentFilter == 'this_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_month')"
                  >{{ $t('this month') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_year'"
                  :outline="currentFilter != 'this_year'"
                  :color="currentFilter == 'this_year' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_year')"
                  >{{ $t('this year') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_month'"
                  :outline="currentFilter != 'last_month'"
                  :color="currentFilter == 'last_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_month')"
                  >{{ $t('last 30 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_365_day'"
                  :outline="currentFilter != 'last_365_day'"
                  :color="currentFilter == 'last_365_day' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_365_day')"
                  >{{ $t('last 365 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'custom_date'"
                  :outline="currentFilter != 'custom_date'"
                  :color="currentFilter == 'custom_date' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('custom_date')"
                  >{{ $t('Custom Date') }}</v-btn
                >
              </div>
              <div class="col s12 m4 text-xs-left text-sm-right">
                <a
                  href="javascript:void(0)"
                  class="btn btn-floating btn-small btn-outline-red"
                  :class="{ active: view == 'tag' }"
                  @click="view = 'tag'"
                >
                  <span class="fas fa-th"></span>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-floating btn-small btn-outline-red"
                  :class="{ active: view == 'list' }"
                  @click="view = 'list'"
                >
                  <span class="fas fa-bars"></span>
                </a>

                <v-btn
                  depressed
                  outline
                  color="primary"
                  :loading="loading"
                  :disabled="filterDefaultIntents.length == 0"
                  @click="onExportTraining"
                >
                  <em class="fas fa-file-export" />
                  &nbsp;{{ $t('export') }}&nbsp;
                  <v-premium-lock :inline="true"></v-premium-lock>
                </v-btn>
              </div>

              <div v-if="currentFilter == 'custom_date'" class="row" style="margin-bottom: 0">
                <div class="col s12 m6">
                  <span class="dashboard_datepicker">
                    {{ $t('from') }}:
                    <datepicker
                      v-model="selectedDate.start"
                      style="margin-bottom: 10px"
                      @selected="onSelectedStartDate"
                    ></datepicker>
                  </span>
                </div>
                <div class="col s12 m6">
                  <span class="dashboard_datepicker" style="margin-bottom: 10px">
                    {{ $t('to') }}:
                    <datepicker
                      v-model="selectedDate.end"
                      style
                      @selected="onSelectedEndDate"
                    ></datepicker>
                  </span>
                </div>
                <div class="col s12">
                  <div class="text-xs-right">
                    <v-btn color="primary" small :loading="loading" @click="loadTraining">
                      {{ $t('Search') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-container v-if="selectedBot.theme == 'universalutilities'" fluid>
            <div v-if="selectedBot.uu_areaname" class="primary--text">
              {{ selectedBot.uu_areaname }}
            </div>
            <template v-else>
              <multiselect
                v-model="uuAreaName"
                v-validate="'required'"
                :options="$store.state.uuAreaName"
                select-label
                selected-label
                :searchable="false"
                deselect-label
                data-vv-as="ประปา"
                data-vv-name="uuAreaName"
                @select="onSelectUuAreaName"
                @remove="onSelectUuAreaName('')"
              ></multiselect>
            </template>
          </v-container>
          <div v-if="firstloading">
            <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
          </div>
          <template v-else>
            <template v-if="filterDefaultIntents.length > 0">
              <div style="padding: 0 15px">
                <div>
                  <div
                    style="
                      background: #eee;
                      padding: 15px 15px 0;
                      margin-bottom: 15px;
                      border-radius: 5px;
                    "
                  >
                    <div class="row" style="margin-bottom: 0">
                      <div class="col s12 m5">
                        <v-checkbox
                          v-model="allSelected"
                          color="primary"
                          :label="$t('Select All')"
                          style="margin-top: 0"
                        ></v-checkbox>
                      </div>
                      <div class="col s12 m7 text-xs-left text-sm-right">
                        <v-btn
                          href="javascript:void(0)"
                          outline
                          color="grey"
                          :loading="loading || loadingIntent"
                          class="primaryButton"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="
                            $store.getters.getPackage == 'premium' && !isCoachlab
                              ? ignoreAll()
                              : false
                          "
                          >{{ $t('Delete') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="createNewAll"
                          >{{ $t('Create new') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="
                            currentDefaultIntents = selectedQuestionData
                            showModal = true
                          "
                          >{{ $t('Add existing') }}</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="container-fluid" style="padding: 0 15px">
              <div
                id="training_container"
                style="
                  max-height: 600px;
                  overflow-y: auto;
                  border: 1px solid #eee;
                  padding: 10px;
                  border-radius: 5px;
                "
              >
                <div class="text-xs-center">
                  <v-pagination
                    v-if="!loading && !search"
                    v-model="pageNumber"
                    :length="pageCount"
                    class="mb-2"
                    @input="onClickPageinate"
                  ></v-pagination>
                </div>
                <div class="row" style="margin-bottom: 0">
                  <div class="col s12">
                    <template v-if="filterDefaultIntents.length > 0">
                      <div class="container-fluid">
                        <template v-if="view == 'tag'">
                          <ul class="tags">
                            <li
                              v-for="(intent, index) in filterDefaultIntents"
                              :key="'intent_' + intent.id + '_' + index"
                              class="tag"
                              :class="{ active: intent.selected }"
                              style="
                                margin-right: 5px;
                                margin-bottom: 5px;
                                cursor: pointer;
                                text-align: left;
                              "
                              :title="intent.questiondata"
                              @click="intent.selected = !intent.selected"
                            >
                              <span
                                :class="{
                                  'fas fa-check-circle': intent.selected,
                                  'far fa-circle': !intent.selected
                                }"
                              ></span>
                              <div
                                style="
                                  display: inline-block;
                                  vertical-align: middle;
                                  word-break: break-all;
                                "
                              >
                                {{ intent.questiondata }}
                              </div>
                              <template v-if="intent.count > 1">({{ intent.count }})</template>
                            </li>
                          </ul>
                        </template>

                        <template v-else>
                          <training-item
                            v-for="(intent, index) in filterDefaultIntents"
                            :key="'intent_' + intent.id + '_' + index"
                            v-model="filterDefaultIntents[index]"
                            :loading-id="loadingId"
                            class="z-border-red"
                            style="padding: 10px 10px 0"
                            :excluded-intent-name="excludedIntentName"
                            @onAddExistingConversation="
                              currentDefaultIntents = []
                              currentDefaultIntents.push(intent.questiondata)
                              showModal = true
                            "
                            @onSaveTrainingConversation="saveTrainingIntent"
                            @onIgnore="onIgnore(intent.questiondata)"
                          ></training-item>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-xs-center" style="margin: 35px 0">
                        <img
                          src="/static/img/assets/setting/conversation.png"
                          alt
                          style="width: 230px"
                        />
                        <h3>{{ $t('No conversation') }}</h3>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="text-xs-center">
                  <v-pagination
                    v-if="!loading && !search"
                    v-model="pageNumber"
                    :length="pageCount"
                    class="mb-2"
                    @input="onClickPageinate"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="height: 60px"></div>

        <v-dialog v-model="showModal" scrollable persistent max-width="1000">
          <v-card>
            <template v-if="showModal">
              <div class="pa-2">
                <h5>{{ $t('Training') }}</h5>
                <div class="form-control">
                  <input v-model="searchIntent" type="text" :placeholder="$t('Search')" />
                </div>
              </div>

              <v-divider />
              <v-card-text style="max-height: 600px">
                <ul class="training-data" style="margin: 0; padding: 0">
                  <li
                    v-for="(intent, index) in filterIntents"
                    :key="'intent_' + index"
                    class="item z-border-red mb-2"
                  >
                    <v-layout class="training-title">
                      <v-flex class="pa-2">
                        {{ intent.intentname }}
                      </v-flex>
                      <v-flex shrink>
                        <v-btn color="primary" @click="addTrainingToConversation(intent)">
                          {{ $t('select') }}
                        </v-btn>
                      </v-flex>
                      <v-flex shrink>
                        <v-btn icon @click="handleSelectPreviewIntent(intent)">
                          <v-icon>
                            {{
                              currentIntent && currentIntent.id == intent.id
                                ? 'keyboard_arrow_up'
                                : 'keyboard_arrow_down'
                            }}
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <template v-if="currentIntent && currentIntent.id == intent.id">
                      <v-divider />
                      <PreviewConversation
                        class="pa-2"
                        :show-multiple-channel="showMultipleChannel"
                        :intent="intent"
                        :answers="answers"
                        :tab="tab"
                        :multi-messages="{
                          fb_answers,
                          line_answers,
                          ig_answers,
                          ms_team_answers
                        }"
                        :fb_answers="fb_answers"
                        :line_answers="line_answers"
                        :ig_answers="ig_answers"
                        :ms_team_answers="ms_team_answers"
                        @handleChangeTab="tab = $event"
                      />
                    </template>
                  </li>
                </ul>
              </v-card-text>

              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" depressed @click="showModal = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-spacer />
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </template>
      <template v-else-if="currentView == 'create_new'">
        <div class="container">
          <div class="row">
            <div class="col s12">
              <manage-intent
                v-model="newIntent"
                :type="'add'"
                :excluded-intent-name="excludedIntentName"
                @close="onClose"
                @saveIntent="onSaveIntent"
              ></manage-intent>
            </div>
          </div>
        </div>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TrainingItem from './TrainingItem'
import api from '@/api'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ManageIntent from './intent-manage'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'

import PreviewConversation from '@/components/elements/Conversation/PreviewConversation'

import XLSX from 'xlsx'
export default {
  name: 'TrainingComponent',
  components: {
    TrainingItem,
    datepicker,
    ScaleLoader,
    ManageIntent,
    PreviewConversation
  },
  data: function () {
    return {
      tmp_intent: [],
      alltrainingdata: [],
      pageNumber: 1,
      size: 50,
      loadingId: '',
      currentView: 'list',
      training_intents: [],
      loading: false,
      loadingIntent: true,
      firstloading: true,
      intents: [],
      search: '',
      searchIntent: '',
      showModal: false,
      currentDefaultIntents: [],
      allSelected: false,
      selectedDate: {
        start: moment().startOf('month').toDate(),
        end: moment().endOf('month').toDate()
      },
      currentFilter: 'this_month',
      ignoreInterval: undefined,
      ignoreCount: 0,
      view: 'tag',
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      training_process_count: 0,
      loadingTraining: null,
      uuAreaName: '',
      currentIntent: null,

      trainingCount: 0,
      offset: 0,
      total: 0,
      tab: 'fb'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    pageCount: function () {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s)
      // return 10
    },
    excludedIntentName: function () {
      const vm = this
      const result = vm.intents.map((intent) => {
        return intent && intent.intentname ? intent.intentname : null
      })

      return (result || []).join(',')
    },
    filterDefaultIntents: function () {
      const vm = this
      const sorted = vm.training_intents.slice(0).sort(function (a, b) {
        const nameA = a.questiondata.toUpperCase()
        const nameB = b.questiondata.toUpperCase()
        if (nameA < nameB) {
          return -1
        } else if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      const training = sorted.filter((intent) => {
        let isFound = false
        if (intent.questiondata != null && intent.questiondata != '') {
          isFound =
            intent.questiondata.toLowerCase().includes(vm.search.toLowerCase()) &&
            intent.training != true
        }
        return isFound
      })
      return training
    },
    filterIntents: function () {
      const vm = this
      vm.intents.slice(0).sort(function (a, b) {
        const nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        const nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        // names must be equal
        return 0
      })

      return vm.intents.filter((intent) => {
        if (intent && intent.intentname) {
          return intent.intentname.toLowerCase().includes(vm.searchIntent.toLowerCase())
        } else return false
      })
    },
    selectedQuestionData: function () {
      const questions = []
      const vm = this
      if (vm.filterDefaultIntents) {
        vm.filterDefaultIntents.map(function (el) {
          if (el.selected) {
            questions.push(el.questiondata)
          }
        })
      }
      return questions
    },
    showMultipleChannel() {
      if (!this.currentIntent) {
        return false
      }
      const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.currentIntent, `${social.value}_val`) &&
          this.currentIntent[`${social.value}_val`]
        )
      })
      return hasMultipleChannel ? true : false
    },
    answers: function () {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.a_val, vm.currentIntent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    fb_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    line_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ig_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ms_team_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ms_team_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    replies: function () {
      const vm = this
      if (!vm.currentIntent) {
        return []
      }
      if (vm.currentIntent.quick_reply !== '' && vm.currentIntent.quick_reply != null) {
        return vm.currentIntent.quick_reply.split(',')
      } else {
        return []
      }
    }
  },
  watch: {
    allSelected: function (newVal, oldVal) {
      const vm = this
      if (newVal != oldVal) {
        vm.selectAll()
      }
    }
  },
  mounted: async function () {
    const vm = this
    if (vm.$store.getters.getPackage != 'premium' || vm.isCoachlab) {
      return false
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto
    }
    if (vm.$route.query.datefrom || vm.$route.query.dateto) {
      vm.currentFilter = 'custom_date'
    }

    vm.firstloading = true
    try {
      const response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
      vm.training_intents = response.training
      vm.total = response.total
    } catch (error) {
      console.error(error)
    }
    vm.firstloading = false
    this.loadingIntent = true
    try {
      vm.intents = []
      const intents = await vm.getIntent()
      vm.intents = intents
    } catch (error) {
      console.error(error)
    }
    this.loadingIntent = false
  },
  methods: {
    handleSelectPreviewIntent(intent) {
      if (!this.currentIntent || this.currentIntent.id != intent.id) {
        this.currentIntent = intent
      } else {
        this.currentIntent = null
      }
    },
    onSelectUuAreaName: function (type) {
      const vm = this
      vm.loading = true
      vm.uuAreaName = type
      this.getTrainingConversation().then(
        function () {
          vm.loading = false
        },
        function (error) {
          console.error(error)
          vm.loading = false
        }
      )
    },

    async onClickPageinate(pageNum) {
      this.pageNumber = pageNum
      this.firstloading = true
      if (pageNum == 1) {
        this.offset = 0
      } else {
        this.offset = (pageNum - 1) * this.size
      }
      try {
        const response = await this.getTrainingConversation({
          limit: this.size,
          offset: this.offset
        })
        this.training_intents = response.training
        if (response.training.length == 0) {
          this.total = pageNum * this.size
        } else {
          this.total = response.total
        }
      } catch (error) {
        console.log(error)
      }
      this.firstloading = false
      await this.$nextTick()
      $('html, body').animate({
        scrollTop: 0
      })
      $('#training_container').animate({
        scrollTop: 0
      })
    },
    onSaveIntent: async function (payload) {
      const vm = this
      vm.loading = true
      vm.currentView = 'list'
      if (vm.selectedQuestionData) {
        vm.loading = true
        vm.training_process_count = vm.selectedQuestionData.length
        const questionDataIntents = vm.training_intents.filter((intent) => {
          return intent.selected
        })
        const datapayload = {
          intentname: payload.intentname,
          chatloglist: [].concat.apply(
            [],
            questionDataIntents.map((el) => el.idlist)
          ) //merge all array
        }
        await vm.saveTrainingIntent(datapayload)

        vm.loading = false
      }
    },
    onClose: function () {
      this.currentView = 'list'
    },
    onSelectedStartDate: async function (value) {
      const vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    createNewAll: function () {
      const vm = this

      vm.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: vm.selectedQuestionData.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      vm.currentView = 'create_new'
    },
    onSelectedEndDate: async function (value) {
      const vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadTraining() {
      this.loading = true
      try {
        this.offset = 0
        const response = await this.getTrainingConversation({
          limit: this.size,
          offset: this.offset
        })
        this.training_intents = response.training
        this.total = response.total
        this.pageNumber = 1
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    onSelectedDate: async function () {
      const vm = this
      vm.loading = true
      try {
        vm.offset = 0
        const response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
        vm.training_intents = response.training
        vm.total = response.total
        vm.pageNumber = 1
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    changeDate: function (value) {
      const vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break
        case 'custom_date':
          break
      }
    },
    getTrainingConversation: function (pageinate) {
      const vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          intentname: '{default}',
          datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          limit: pageinate.limit,
          offset: pageinate.offset,
          training: 'false'
        }
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.uu_areaname = vm.selectedBot.uu_areaname
          } else if (vm.uuAreaName != '') {
            data.uu_areaname = vm.uuAreaName
          }
        }
        api.getTraningConversation(data, function (error, response) {
          if (error) {
            reject(error)
          }
          let training_intents = []
          response.data.map((intent) => {
            let tmp_intent = intent
            tmp_intent.selected = false

            let isFound = false
            training_intents.forEach((value, index) => {
              if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
                training_intents[index].count += 1
                training_intents[index].idlist.push(tmp_intent.id)
              }
              if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
                isFound = true

                return false
              }
            })

            if (!isFound) {
              tmp_intent.count = 1
              Object.assign(tmp_intent, { idlist: [tmp_intent.id] })

              training_intents.push(tmp_intent)
            }
          })

          resolve({
            training: training_intents,
            total: response.total ? response.total : 0
          })
        })
      })
    },
    getIntent: async function () {
      let vm = this
      const params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          const intents = data.map((val) => {
            let intent = val
            intent.isShow = false
            intent.ableToDelete = true
            if (intent.intentname == '{default}') {
              intent.ableToDelete = false
              vm.default_intent = intent
            } else {
              return intent
            }
          })
          return intents
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    addTrainingToConversation: async function (intent) {
      let vm = this
      if (
        !vm.currentDefaultIntents ||
        (vm.currentDefaultIntents && vm.currentDefaultIntents.length == 0)
      ) {
        return false
      }

      let data = {
        q_val: vm.currentDefaultIntents.join(','),
        pageid: vm.selectedBot.pageid
      }

      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to add {question} to {intent}?', {
          question: (
            vm.currentDefaultIntents[0] + (vm.currentDefaultIntents.length > 1 ? '...' : '')
          )
            // eslint-disable-next-line no-useless-escape
            .replace(/\<|\>/g, ''),
          // eslint-disable-next-line no-useless-escape
          intent: intent.intentname.replace(/\<|\>/g, '')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.showModal = false
        data['id'] = intent.id
        const request = {
          data: data,
          params: {
            id: data['id']
          }
        }
        try {
          await this.putQvalIntents(request)
          if (vm.currentDefaultIntents) {
            const questionDataIntents = vm.training_intents.filter((intent) => {
              return intent.selected
            })
            const datapayload = {
              intentname: intent.intentname,
              chatloglist: [].concat.apply(
                [],
                questionDataIntents.map((el) => el.idlist)
              ) //merge all array
            }

            await vm.saveTrainingIntent(datapayload)

            vm.currentDefaultIntents = []
            vm.loading = false
          }
        } catch (error) {
          console.error(error)
          vm.loading = false
        }
      }
    },
    putQvalIntents(request) {
      return new Promise((resolve, reject) => {
        api.putQvalIntents(request, function (error) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    putupdateTrainingConversation: function (data, callback) {
      const vm = this
      api.putupdateTrainingConversation(data, function (error) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (vm.training_intents.length <= 0) {
          callback(null)
          return false
        }
        const training_intents_index = vm.training_intents.findIndex((intent) => {
          return intent.questiondata == data.questiondata
        })
        if (training_intents_index != -1) {
          callback(training_intents_index)
        }
      })
    },
    saveTrainingIntent: function (payload) {
      const vm = this
      return new Promise((resolve, reject) => {
        const data = {
          pageid: vm.selectedBot.pageid,
          questiondata: payload.questiondata,
          chatloglist: payload.chatloglist,
          newintent: payload.intentname
        }
        api.putupdateTrainingConversation(data, function (err, response) {
          if (err) {
            reject(err)
            return false
          }
          if (response && response.responsecode == 200) {
            vm.training_intents = vm.training_intents.filter((el) => {
              return !payload.chatloglist.includes(el.id)
            })

            resolve(response)
          } else {
            reject()
          }
        })
      })
    },
    ignoreAll: async function () {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loading = true

        const ignoreIntents = vm.training_intents.filter((intent) => {
          return intent.selected
        })
        vm.ignoreTrainingIntent(
          [].concat.apply(
            [],
            ignoreIntents.map((el) => el.idlist)
          )
        )
        const questiondata = ignoreIntents.map((intent) => {
          return intent.questiondata
        })

        const filterTraining = vm.training_intents.filter((intent) => {
          return !questiondata.includes(intent.questiondata)
        })

        vm.training_intents = filterTraining

        vm.loading = false
      }
    },
    onIgnore: async function (id) {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.loadingId = id
        try {
          await vm.ignoreTrainingIntent(id)
          const filterTraining = vm.training_intents.filter((intent) => {
            return intent.questiondata != id
          })
          vm.training_intents = filterTraining
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
      }
    },
    ignoreTrainingIntent: function (chatloglist) {
      const vm = this
      return new Promise((resolve) => {
        const data = {
          pageid: vm.selectedBot.pageid,
          chatloglist: chatloglist,
          newintent: ''
        }
        vm.putupdateTrainingConversation(data, function () {
          resolve()
        })
      })
    },
    selectAll: function () {
      const vm = this
      vm.intentId = []
      vm.filterDefaultIntents.forEach((intent) => {
        vm.training_intents.forEach((dintent, dindex) => {
          if (intent.id == dintent.id) {
            vm.training_intents[dindex].selected = vm.allSelected
            return false
          }
        })
      })
    },
    select: function () {
      this.allSelected = false
    },
    onExportTraining: async function () {
      const vm = this
      if (vm.loading) {
        return false
      }
      vm.loading = true
      const response = await vm.getTrainingConversation({ limit: vm.total, offset: 0 })
      const training_intents = response.training
      const json = training_intents.map((val) => ({
        message: (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / '),
        count: val.count > 0 ? val.count : 0
      }))

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'training.xlsx')
      vm.loading = false
    }
  }
}
</script>

<style scoped>
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training.vue